import { createMap, createLandmarks } from './mapbox';
import mapboxgl from 'mapbox-gl';

const singleMap = document.querySelector('.single-map');
const singleMapMarker = document.querySelector('.single-map-marker');

if (singleMap && singleMapMarker) {
    const lng = singleMapMarker.dataset.lng;
    const lat = singleMapMarker.dataset.lat;

    if (lng && lat) {
        const map = createMap({
            container: singleMap,
            center: [lng, lat],
            zoom: 14,
        });

        const bounds = new mapboxgl.LngLatBounds();
        const markers = [];

        markers.push(new mapboxgl.Marker(singleMapMarker).setLngLat([lng, lat]).addTo(map));
        bounds.extend([lng, lat]);

        createLandmarks(map, markers, bounds);

        map.fitBounds(bounds, { padding: (window.matchMedia('(max-width: 767px)').matches ? 40 : 80), maxZoom: 14, duration: 0 });
        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl({
            showCompass: false,
            showZoom: true
        }));
    }
}